import React from 'react';

const AdminAnalytics: React.FC = () => {
  return (
    <div className="container">
      <h1>Analytics</h1>
      <p>Admin analytics dashboard</p>
    </div>
  );
};

export default AdminAnalytics;
